import { ErrorMessage } from "src/components/common/ErrorMessage"
import { errorText } from "src/components/common/errorText"
import { localizeText } from "src/localization/utils"

export const GenericErrorMessage = () => {
  const T = localizeText(errorText)

  return <ErrorMessage message={T.message} />
}
